import type { FetchOptions } from "../helpers/backendRequestHelpers";
import { fetchRequest, reactQueryPost } from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

interface DownloadParticipantsCSVParams extends FetchOptions {
  id?: string | number;
}

const downloadParticipantsCSV = ({
  id,
  ...fetchRequestOptions
}: DownloadParticipantsCSVParams) =>
  fetchRequest<unknown>(
    internalApi.liveStreams.downloadParticipantsCSV({ id }),
    {
      method: "GET",
      ...fetchRequestOptions,
    },
  );
interface InviteParticipantsParams {
  formData: InviteParticipantsPayload;
  roomId?: string | number;
}

interface InviteParticipantsPayload {
  community_member_ids: string[];
}

const inviteParticipants = ({ roomId, formData }: InviteParticipantsParams) =>
  reactQueryPost<unknown, InviteParticipantsPayload>(
    internalApi.liveStreams.inviteParticipants({ roomId }),
    formData,
  );

interface RemoveParticipantParams {
  participantId?: string | number;
  peerId: string | number;
  roomId?: string | number;
}

const removeParticipant = ({
  roomId,
  participantId,
  peerId,
  ...fetchRequestOptions
}: RemoveParticipantParams) =>
  reactQueryPost<unknown, object>(
    internalApi.liveStreams.removeParticipant({
      roomId,
      participantId,
    }),
    {
      peerId,
      ...fetchRequestOptions,
    },
  );

export const liveStreamApi = {
  downloadParticipantsCSV,
  inviteParticipants,
  removeParticipant,
};

export const participantsApi = {
  downloadParticipantsCSV,
  inviteParticipants,
  removeParticipant,
};
